import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/TextNew';

import { userStore } from 'stores/global';

import { isAssetLibrarySubView } from '../assetLibraryView';
import { useStore } from '../assetLibraryStore';
import { getAssetLibraryTitle } from '../utils';
import AssetLibrarySubViewHeader from './AssetLibrarySubViewHeader';
import AssetLibraryViewNavButtons from './AssetLibraryViewNavButtons';

export interface AssetLibraryEmbeddedHeaderProps {
  titleSuffix?: string;
}

export default function AssetLibraryEmbeddedHeader({
  titleSuffix,
}: AssetLibraryEmbeddedHeaderProps) {
  const store = useStore();
  const { libraryView } = store.state;
  const { organizationInfo } = useSnapshot(userStore.state);
  const libraryTitle = getAssetLibraryTitle(organizationInfo?.planType);

  if (isAssetLibrarySubView(libraryView)) {
    return (
      <div className="flex flex-none flex-col gap-4 p-6 pt-8 pb-4">
        <AssetLibrarySubViewHeader embedded />
      </div>
    );
  }

  return (
    <div className="flex flex-none flex-wrap items-center justify-between gap-4 p-6 pt-8 pb-4">
      <Text
        as="h2"
        token="display/20/medium"
        leading="body"
        className="text-primary flex-none text-pretty"
      >
        {libraryTitle}
        {titleSuffix ? (
          <span className="text-tertiary">{titleSuffix}</span>
        ) : null}
      </Text>
      <AssetLibraryViewNavButtons compact />
    </div>
  );
}
